/**
 * Lazy Load Third-Party Scripts
 * Optimizes performance by loading non-critical scripts after page load
 * Reduces Total Blocking Time and Time to Interactive
 */

(function() {
  'use strict';

  // Configuration: Add scripts to lazy load here
  const LAZY_LOAD_DELAY = 2000; // Wait 2 seconds after page load
  
  /**
   * Load a script dynamically
   */
  function loadScript(src, async = true, defer = true) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = async;
      script.defer = defer;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  /**
   * Lazy load third-party widgets after page becomes interactive
   */
  function lazyLoadThirdParty() {
    // Wait for page to be fully loaded and interactive
    setTimeout(() => {
      // Example: Lazy load review widgets
      const reviewsContainer = document.querySelector('[data-reviews-widget]');
      if (reviewsContainer) {
        // Load reviews script only when visible
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              console.log('Loading reviews widget...');
              // Add your reviews widget script here
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '50px' });
        
        observer.observe(reviewsContainer);
      }

      // Example: Lazy load subscription widgets
      const subscriptionWidget = document.querySelector('[data-subscription-widget]');
      if (subscriptionWidget) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              console.log('Loading subscription widget...');
              // Seal Subscriptions script will load here
              observer.unobserve(entry.target);
            }
          });
        }, { rootMargin: '50px' });
        
        observer.observe(subscriptionWidget);
      }
    }, LAZY_LOAD_DELAY);
  }

  /**
   * Initialize when DOM is ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lazyLoadThirdParty);
  } else {
    lazyLoadThirdParty();
  }

})();
